import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true
});

api.interceptors.response.use(
    (response) => response,

    async (error) => {
        if (error.response?.status === 401) {

            console.log("Session expired. Logging out...");

            try {
                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}payment-portal-logout`,
                    {},
                    {
                        withCredentials: true
                    }
                );
            } catch (logoutError) {
                console.error(
                    "Automatic logout API failed:",
                    logoutError
                );
            }

            localStorage.removeItem("authUser");

            localStorage.setItem(
                "logout-event",
                Date.now().toString()
            );

            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default api;